import { ApiResponse } from '@interfaces/index';
import { apiUrlConfig } from './configs/apiUrlConfig';
import createApiClient from './configs/httpHandler';

export const engagementApiHandler = {
  getLatestUserEngagements: async (): Promise<ApiResponse<UserEngagement>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(`/get-user-latest-engagement`),

  getAllEngagementTiers: async (): Promise<ApiResponse<EngagementTier[]>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(`/get-all-engagement-tiers`),

  getEngagementUserStreak: async (): Promise<ApiResponse<EngagementUserStreak>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(`/get-user-streak`),

  createEngagementUserStreak: async (): Promise<ApiResponse<EngagementUserStreak>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).post(`/create-user-streak`),
};

export const fetchCurrentEngagement = async (): Promise<ApiResponse<UserEngagement>> =>
  engagementApiHandler.getLatestUserEngagements();

export const fetchUserStreak = async (): Promise<ApiResponse<EngagementUserStreak>> =>
  engagementApiHandler.getEngagementUserStreak();

export interface EngagementTier {
  id: number;
  tierName: string;
  minPoints: number;
  maxPoints: number;
  description: string;
  badgeImageUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UserEngagement {
  id: number;
  userId: number;
  totalPoints: number;
  currentTier: string;
  createdAt: string;
  updatedAt: string;
  engagementTier: EngagementTier;
}

export interface EngagementUserStreak {
  id: number;
  userId: number;
  currentStreak: number;
  longestStreak: number;
  lastActivityDate: string;
  createdAt: string;
  updatedAt: string;
}
